import React, { useEffect, useState  } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextareaAutosize from 'react-textarea-autosize';
import Dropdown from 'react-bootstrap/Dropdown'
import { useHistory } from 'react-router';
import {s3Link} from '../utils/constants';
import {checkImageExist} from '../utils/helper'
import moment from 'moment'
import { useToasts } from "react-toast-notifications";
import Stories from 'react-insta-stories';

import DefaultAvatar from '../images/default_avatar.jpg';

const UserStoriesItem = ({ currentUser, user, hide, avatar }) => {
    const { addToast } = useToasts();
    const history = useHistory();
    const playerDuration = 15000
    const [playingIcon, setPlayingIcon] = useState('');
    const [playing, setPlaying] = useState(false);
    const [storyIndex, setStoryIndex] = useState();
    const [message, setMessage] = useState('')
    const [sendingReply, setSendingReply] = useState(false)
    const [userAvatar, setUserAvatar] = useState('')

    useEffect(() => {
        let isMounted = true;
        setStoryIndex(0)
        setPlaying(false)
        return () => { isMounted =false }
    }, [])
    /*
    const handleSetPlaying = (e) => {
        console.log('clicked')
        setPlaying(!playing)

        if( playing ){
            setPlayingIcon(<FontAwesomeIcon icon={['fas', 'play']} />)
        }else{
            setPlayingIcon(<FontAwesomeIcon icon={['fas', 'pause']} />)
        }
    }*/

    const clickTextPause = (e) => {
        // e.preventDefault()
        // e.stopPropagation()
        
        setPlaying(true)
        setPlayingIcon(<FontAwesomeIcon icon={['fas', 'play']} />)
    }

    const handleGoToPu = (e, login) => {
        e.preventDefault()
        history.push(`/${login}`)
    }

    const [theStories, setTheStories] = useState([]);
    const [render, setRender] = useState(false)

    // const [avatar, setAvatar] = useState('')
    const [isCheckingAvatar, setIsCheckingAvatar] = useState(false)

    const getUserStories = async () => {
        let isMounted = true;
        await axios.get(`/api/user-stories`, {
            params:{
                pu_id: user.id
            }
        })
        .then(response => {
            if (isMounted || !isCheckingAvatar) {
                const storyCollection = response.data.map(function(item){
                    let url = '';
                    let type = (item.medias[0].type.toUpperCase() === 'VIDEO') ? 'video' : 'image';
                    let duration = playerDuration

                    if (type === 'video') {
                        duration = item.medias[0].vid_duration
                            ? parseInt((item.medias[0].vid_duration).replace('s', '')) * 1000
                            : playerDuration;
                        url = `${s3Link}/${item.medias[0].file_path}`;
                    }
    
                    if (type=== 'image') {
                        let imgSrc = item.medias[0].thumb_path ?? item.medias[0].file_path
                        url = `${s3Link}/${imgSrc}`;
                    }

                    // // console.log("🚀 ~ file: UserStoriesItem.js ~ line 95 ~ storyCollection ~ userAvatar", userAvatar)

                    const story = {
                        id: item.id,
                        url: url,
                        type: type,
                        duration: duration,
                        header: {
                            heading: user.nicename || user.login,
                            subheading: moment(moment.utc(item.created_at).local().format()).fromNow(),
                            profileImage: avatar
                        }
                    };
                    
                    // console.log("🚀 ~ file: UserStoriesItem.js ~ line 102 ~ storyCollection ~ story", story)

                    return story

                    // console.log({tempData})
                    // setTheStories(oldStories => [...oldStories, tempData])
                })

                setTheStories(storyCollection)
            }
        }).catch(error => {
            console.log({error})
        }).finally(() => {
            setRender(true)
            
            isMounted = false;
        })
    }


    const handleDelete = async (e) => {
        e.preventDefault()
        e.stopPropagation()

        await axios.delete(`/api/stories/${theStories[storyIndex].id}`)
            .then(response => {
                addToast('Story has been deleted', { appearance: 'success', autoDismiss: true });
                setStoryIndex(0)
                
                theStories.splice(storyIndex, 1)
                setTheStories([...theStories])

                if (theStories.length <= 0) {
                    hide(true)
                }

            })
            .catch(error => {
                addToast('Unable to remove story', { appearance: 'error', autoDismiss: true });
            })
    }

    useEffect(() => {
        if (playing) {
            setPlayingIcon(<FontAwesomeIcon icon={['fas', 'play']} />)
        } else {
            setPlayingIcon(<FontAwesomeIcon icon={['fas', 'pause']} />)
        }
    }, [playing])

    const handleReply = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        console.log('Reply message' , { user })

        if (! message) {
            return false;
        }
        setSendingReply(true)
        await axios.post('/api/stories/reply', {
            message,
            rec_id: user.id,
            story: theStories[storyIndex].id
        })
        .then(response => {
            addToast('Message successfully sent', { appearance: 'success', autoDismiss: true });
            setMessage('')
        })
        .catch(error => {
            let message = 'Unable to send message';
            if (error.response.status === 403) {
                message = 'Message to own story not allowed'
            }

            addToast(message, { appearance: 'error', autoDismiss: true })
        })
        .then(() => {
            setSendingReply(false)
        })
    }   

    useEffect(() => {
        getUserStories()
    }, [user])

    useEffect(() => {
        // console.log("🚀 ~ file: UserStoriesItem.js ~ line 183 ~ UserStoriesItem ~ storyIndex", storyIndex)
        console.log({ playing })
    }, [storyIndex])

    const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        hide(true)
    }



    return (
        <div className="userSlick-container">
            { theStories.length > 0 && render && <Stories
                    stories={theStories}
                    isPaused={playing}
                    // onAllStoriesEnd={hide}
                    onStoryStart={(storyIndex) => {
                        setStoryIndex(storyIndex);
                        setPlaying(true)
                    }}
                    currentIndex={storyIndex}
                />
            }

            {/* <div className="slider-playpause-control">
                <button onClick={handleSetPlaying}>
                    {playingIcon}
                </button>
            </div> */}
            <div className="story-message-user-container">
                <div className="story-message-user">
                    <TextareaAutosize
                        rows={1}
                        name="story-message"
                        placeholder={'Reply to ' + `${user.login}`}
                        onFocus={clickTextPause}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        maxRows={message ? 6 : 1}
                        style={{ overflowY: 'auto' }}
                    />
                    <a onClick={handleReply}><FontAwesomeIcon icon={['fas', 'paper-plane']} /></a>
                </div>
            </div>
            <div className="story-more-option">
                { user.id !== currentUser.id 
                    ? ''
                    :
                    <Dropdown drop="down" className="story-options" onClick={clickTextPause}>
                        <Dropdown.Toggle>
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                        </Dropdown.Toggle>
                        
                        {/* <Dropdown.Menu>
                            <Dropdown.Item href="#">Report Inappropriate</Dropdown.Item>
                            <Dropdown.Item href="#">Cancel</Dropdown.Item>
                        </Dropdown.Menu> */}
                        <Dropdown.Menu>
                            <Dropdown.Item href="#" onClick={(e) => handleDelete(e, playing)}>Delete</Dropdown.Item>
                            <Dropdown.Item href="#">Cancel</Dropdown.Item>
                            {/* <Dropdown.Item href="#" onClick={handleClose}>Close</Dropdown.Item> */}
                            {/* <Dropdown.Item href="#">Save Video</Dropdown.Item>
                            <Dropdown.Item href="#">Send to..</Dropdown.Item>
                            <Dropdown.Item href="#">Share as Post..</Dropdown.Item>
                            <Dropdown.Item href="#">Copy Link</Dropdown.Item>
                            <Dropdown.Item href="#">Share to..</Dropdown.Item>
                            <Dropdown.Item href="#">Story Settings</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                }
                <button type="button" className="story-close" onClick={hide}>
                    <FontAwesomeIcon icon={['fa', 'times']} />
                </button>
            </div>
        </div>
    );
}

export default UserStoriesItem;